"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
var styleUtilities_1 = require("../../../util/styleUtilities");
exports.default = (0, makeStyles_1.default)(function () {
    return (0, core_1.createStyles)({
        root: {
            width: 'max-content',
            maxWidth: '100%',
        },
        statusWrapper: function (_a) {
            var direction = _a.direction;
            return ({
                display: 'grid',
                gridGap: 8,
                gridTemplateColumns: direction === 'column' ? 'auto' : 'auto auto',
                alignItems: 'center',
                justifyItems: 'center',
            });
        },
        status: {
            maxWidth: '100%',
            padding: '4px 8px',
            textAlign: 'center',
            borderRadius: 4,
        },
        gray: {
            backgroundColor: (0, styleUtilities_1.withOpacity)(theme_1.default.colors.dark, 0.2),
        },
        green: {
            backgroundColor: (0, styleUtilities_1.withOpacity)(theme_1.default.colors.tertiary, 0.2),
        },
        red: {
            backgroundColor: (0, styleUtilities_1.withOpacity)(theme_1.default.colors.error, 0.2),
        },
        blue: {
            backgroundColor: (0, styleUtilities_1.withOpacity)(theme_1.default.colors.primaryLight, 0.5),
        },
    });
});
